<template>
	<div class="c-app flex-row align-items-center">
		<CContainer>
			<CRow class="justify-content-center">
				<CCol md="8">
					<CCardGroup>
						<CCard class="p-4">
							<CCardBody>
								<CForm v-on:submit.prevent="login()">
									<h1>Espace d'Administration</h1>
									<p class="text-muted">Connectez-vous à votre compte</p>
									<CInput
										v-model="email"
										placeholder="E-mail"
										autocomplete="username email">
										<template #prepend-content><CIcon name="cil-user" /></template>
									</CInput>
									<CInput
										v-model="password"
										placeholder="Mot de passe"
										type="password"
										autocomplete="curent-password">
										<template #prepend-content><CIcon name="cil-lock-locked" /></template>
									</CInput>
									<CRow>
										<CCol col="6" class="text-left">
											<CButton type="submit" color="primary" class="px-4"
												>Connexion</CButton
											>
										</CCol>
									</CRow>
								</CForm>
							</CCardBody>
						</CCard>
						<CCard
							color="primary"
							text-color="white"
							class="text-center py-5 d-md-down-none"
							body-wrapper>
							<CCardBody>
								<h2>Bienvenue !</h2>
								<p>
									La page d'administration n'est accessible qu'à nos opérateurs. Si vous
									avez perdu vos accès, veuillez contacter le support technique afin de
									confirmer votre identité et le réinitialiser.
								</p>
							</CCardBody>
						</CCard>
					</CCardGroup>
				</CCol>
			</CRow>
		</CContainer>
	</div>
</template>

<script>
	export default {
		name: 'Login',
		data() {
			return {
				email: null,
				password: null,
			};
		},

		methods: {
			login: function () {
				this.$auth
					.login({
						data: {
							email: this.email,
							password: this.password,
						},
					})
					.then(
						res => {
							this.$toast('Connexion réussie !', { type: 'success' });
						},
						error => {
							this.$toast('Vos identifiants ne sont pas valides. Veuillez réessayer.', {
								type: 'error',
							});
						}
					);
			},
		},
	};
</script>
